module.exports = __webpack_public_path__ + "scripts/loading-bubbles-96x96.svg?12decc9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading-bubbles-96x96.svg
// module id = 1308
// module chunks = 1